import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererDocument',
  template: `
    <button *ngIf="params?.data.status == 'Draft' || params.data.status == 'Inactive'" [disabled]="!params.data.editDoc"
      mat-mini-fab
      color="primary"
      [title]="t('Edit', 'Edit')"
      (click)="onClick($event)"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == true ? true : false"
      mat-mini-fab
      color="accent"
      [title]="t('DraftOptions', 'Draft Options')"
      (click)="onClick($event)"
      [hidden]="hideApprovalLvl"
    >
    <mat-icon>assignment</mat-icon></button>
    <button *ngIf="params?.data.status == 'Draft'   &&  params?.data.disableApproved == true ? true : false"
      mat-mini-fab
      color="accent"
      [title]="t('ApproveReject', 'Approve / Reject')"
      (click)="onClick($event)"
      [disabled]="params.data.disableDraft || this.approveReject"
    >
    <mat-icon>check</mat-icon>
    </button>
    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == false ? true : false"
    mat-mini-fab
    color="accent"
    [title]="t('DraftOptions', 'Draft Options')"
    (click)="onClick($event)"
    [disabled]="params.data.disableApproved"
  >
  <mat-icon>alarm icon</mat-icon></button>

  <!--<button *ngIf="params?.data.status == 'Inactive'"
  mat-mini-fab
  color="warn"
  [title]="t('DraftOptions', 'Draft Options')"
  (click)="onClick($event)"
  >
  <mat-icon>warning</mat-icon>
  </button>-->
    <button [hidden]="true"
      mat-mini-fab
      color="accent"
      [title]="t('ViewDocument', 'View Document')"
      (click)="onClick($event)"
    >
      <mat-icon>visibility</mat-icon>
    </button>
    <!-- [disabled]="(params.data.status == 'Draft' && params.data.disableDownload == false) || (params.data.status == 'Active') || (params.data.status == 'Inactive' && params.data.disableDownload == false) || (params.data.status == 'Obsolete' && params.data.disableDownload == false && params.data.disableOtherDownload == false) || (params.data.status == 'Rejected' && params.data.disableDownload == false) ? false : true" -->
    <button [disabled]="(params.data.status == 'Draft' && params.data.disableDownload == false) || (params.data.status == 'Active') || (params.data.status == 'Inactive' && params.data.disableDownload == false) || (params.data.status == 'Obsolete' && params.data.disableDownload == false) || (params.data.status == 'Rejected' && params.data.disableDownload == false) ? false : true"
      mat-mini-fab
      color="warn"
      [title]="t('DownloadDocument', 'Download Document')"
      (click)="onClick($event)"
    >
      <mat-icon>download</mat-icon>
    </button>

    <button
    mat-mini-fab
    color="primary"
    [title]="t('OpenChat', 'Open Chat')"
    (click)="onClick($event)"
    [disabled]="params.data.disableChat"
  >
    <mat-icon>chat</mat-icon>
  </button>

  <button
    mat-mini-fab
    color="accent"
    [title]="t('OpenQuestions', 'Open Questions')"
    (click)="onClick($event)"
    [disabled]="params?.data.status == 'Draft'"
  >
  <mat-icon>forum</mat-icon>
  </button>
  <button
    mat-mini-fab
    color="primary"
    [title]="t('RevisionApprovalHistory', 'Revision Approval History')"
    matTooltip="Revision Approval History"
    (click)="onClick($event)"
  >
  <mat-icon>history</mat-icon>
  </button>

    <!-----
    <button
      mat-mini-fab
      color="warn"
      style="background-color: #000;"
      [title]="t('DocumentQuestions', 'Document Questions')"
      (click)="onClick($event)"
    >
      <mat-icon>question_answer</mat-icon>
    </button>
    ---->
  `,
  styles: [
    `
      button {
        height: 35px;
        width: 35px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0 3px;
      }
      .mat-icon {
        transform: scale(0.7);
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererRevisionHistory implements ICellRendererAngularComp {
  constructor(public translate: TranslateService) {}

  /** langObj (via cellRendererParams.getLangObj, if supplied) -> "Documents.<key>" -> flat key -> English. */
  public t(key: string, fallback: string): string {
    const langObj =
      this.params && typeof this.params.getLangObj === 'function'
        ? this.params.getLangObj()
        : null;
    if (langObj && langObj[key]) {
      return langObj[key];
    }
    for (const candidate of ['Documents.' + key, key]) {
      const value = this.translate.instant(candidate);
      if (typeof value === 'string' && value !== candidate) {
        return value;
      }
      if (value && typeof value === 'object' && typeof value.title === 'string') {
        return value.title;
      }
    }
    return fallback;
  }

  public params: any;
  public approveReject:boolean = true;
  public hideApprovalLvl:boolean = false;
  public ApproversLevelArray:any[]=[];
  isUserSuperAdmin: boolean;

  refresh(params: any): boolean {
    // throw new Error('Method not implemented.');
    this.params = params;
    return true;
  }
  agInit(params: any): void {
    this.ApproversLevelArray = [];
    let userdata = JSON.parse(localStorage.logged_in_user);
    let userCode = userdata.userCode;
    this.params = params;
    this.ApproversLevelArray = this.params?.data?.ApproversEmpInfoIds?.split(',');
    const superAdminArray = this.params?.data?.SuperAdmins?.split(',')
    if(superAdminArray?.includes(userCode))
    {
      // this.approveReject = false;
      this.approveReject = true;
    }
    // if(this.ApproversLevelArray?.includes(userCode))
    if(this.ApproversLevelArray?.some(code => code.trim() === userCode))  
    {
      this.approveReject = false;
    }
    if(params.data?.isOwnerOnly === 'owner')
    {
      if(params.data?.draftOwner === userCode)
      {
        this.approveReject = false;
      }
      this.hideApprovalLvl  = true;
    }  
  }
  onClick($event: any): any {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onClick(params);
    }
  }
}
